import axios from "axios";
import CryptoJS from 'crypto-js';
import moment from 'moment';
import { updateSessionTime, getDebugFlag, setDebugFlag } from "../common/sessionManager";
import { encryptForServer } from "../common/cryptoUtil.js";
// default
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";        
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    if (error.response && error.response.status === 401) {
      //localStorage.removeItem('app_data');
      window.location.href = "/logout";
    } else if (error.response && error.response.status === 403 && error.response.data.Errorcode === "err98") {
      setDebugFlag(1);
      window.location.reload();
    } else if (error.response && error.response.status === 403 && error.response.data.Errorcode === "err99") {
      setDebugFlag(0);
      window.location.reload();
    }
    // else if (error.response && error.response.status === 403) {
    //   setDebugFlag(1);
    //   window.location.reload();
    // }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
let clid 
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

const countryCode={ 
  'Afghanistan':'AF', 
  'Åland Islands':'AX', 
  'Albania':'AL', 
  'Algeria':'DZ', 
  'American Samoa':'AS', 
  'AndorrA':'AD', 
  'Angola':'AO', 
  'Anguilla':'AI', 
  'Antarctica':'AQ', 
  'Antigua and Barbuda':'AG', 
  'Argentina':'AR', 
  'Armenia':'AM', 
  'Aruba':'AW', 
  'Australia':'AU', 
  'Austria':'AT', 
  'Azerbaijan':'AZ', 
  'Bahamas':'BS', 
  'Bahrain':'BH', 
  'Bangladesh':'BD', 
  'Barbados':'BB', 
  'Belarus':'BY', 
  'Belgium':'BE', 
  'Belize':'BZ', 
  'Benin':'BJ', 
  'Bermuda':'BM', 
  'Bhutan':'BT', 
  'Bolivia':'BO', 
  'Bosnia and Herzegovina':'BA', 
  'Botswana':'BW', 
  'Bouvet Island':'BV', 
  'Brazil':'BR', 
  'British Indian Ocean Territory':'IO', 
  'Brunei Darussalam':'BN', 
  'Bulgaria':'BG', 
  'Burkina Faso':'BF', 
  'Burundi':'BI', 
  'Cambodia':'KH', 
  'Cameroon':'CM', 
  'Canada':'CA', 
  'Cape Verde':'CV', 
  'Cayman Islands':'KY', 
  'Central African Republic':'CF', 
  'Chad':'TD', 
  'Chile':'CL', 
  'China':'CN', 
  'Christmas Island':'CX', 
  'Cocos (Keeling) Islands':'CC', 
  'Colombia':'CO', 
  'Comoros':'KM', 
  'Congo':'CG', 
  'Congo, The Democratic Republic of the':'CD', 
  'Cook Islands':'CK', 
  'Costa Rica':'CR', 
  'Cote D\'Ivoire':'CI', 
  'Croatia':'HR', 
  'Cuba':'CU', 
  'Cyprus':'CY', 
  'Czech Republic':'CZ', 
  'Denmark':'DK', 
  'Djibouti':'DJ', 
  'Dominica':'DM', 
  'Dominican Republic':'DO', 
  'Ecuador':'EC', 
  'Egypt':'EG', 
  'El Salvador':'SV', 
  'Equatorial Guinea':'GQ', 
  'Eritrea':'ER', 
  'Estonia':'EE', 
  'Ethiopia':'ET', 
  'Falkland Islands (Malvinas)':'FK', 
  'Faroe Islands':'FO', 
  'Fiji':'FJ', 
  'Finland':'FI', 
  'France':'FR', 
  'French Guiana':'GF', 
  'French Polynesia':'PF', 
  'French Southern Territories':'TF', 
  'Gabon':'GA', 
  'Gambia':'GM', 
  'Georgia':'GE', 
  'Germany':'DE', 
  'Ghana':'GH', 
  'Gibraltar':'GI', 
  'Greece':'GR', 
  'Greenland':'GL', 
  'Grenada':'GD', 
  'Guadeloupe':'GP', 
  'Guam':'GU', 
  'Guatemala':'GT', 
  'Guernsey':'GG', 
  'Guinea':'GN', 
  'Guinea-Bissau':'GW', 
  'Guyana':'GY', 
  'Haiti':'HT', 
  'Heard Island and Mcdonald Islands':'HM', 
  'Holy See (Vatican City State)':'VA', 
  'Honduras':'HN', 
  'Hong Kong':'HK', 
  'Hungary':'HU', 
  'Iceland':'IS', 
  'India':'IN', 
  'Indonesia':'ID', 
  'Iran, Islamic Republic Of':'IR', 
  'Iraq':'IQ', 
  'Ireland':'IE', 
  'Isle of Man':'IM', 
  'Israel':'IL', 
  'Italy':'IT', 
  'Jamaica':'JM', 
  'Japan':'JP', 
  'Jersey':'JE', 
  'Jordan':'JO', 
  'Kazakhstan':'KZ', 
  'Kenya':'KE', 
  'Kiribati':'KI', 
  'Korea, Democratic People\'S Republic of':'KP', 
  'Korea, Republic of':'KR', 
  'Kuwait':'KW', 
  'Kyrgyzstan':'KG', 
  'Lao People\'S Democratic Republic':'LA', 
  'Latvia':'LV', 
  'Lebanon':'LB', 
  'Lesotho':'LS', 
  'Liberia':'LR', 
  'Libyan Arab Jamahiriya':'LY', 
  'Liechtenstein':'LI', 
  'Lithuania':'LT', 
  'Luxembourg':'LU', 
  'Macao':'MO', 
  'Macedonia, The Former Yugoslav Republic of':'MK', 
  'Madagascar':'MG', 
  'Malawi':'MW', 
  'Malaysia':'MY', 
  'Maldives':'MV', 
  'Mali':'ML', 
  'Malta':'MT', 
  'Marshall Islands':'MH', 
  'Martinique':'MQ', 
  'Mauritania':'MR', 
  'Mauritius':'MU', 
  'Mayotte':'YT', 
  'Mexico':'MX', 
  'Micronesia, Federated States of':'FM', 
  'Moldova, Republic of':'MD', 
  'Monaco':'MC', 
  'Mongolia':'MN', 
  'Montserrat':'MS', 
  'Morocco':'MA', 
  'Mozambique':'MZ', 
  'Myanmar':'MM', 
  'Namibia':'NA', 
  'Nauru':'NR', 
  'Nepal':'NP', 
  'Netherlands':'NL', 
  'Netherlands Antilles':'AN', 
  'New Caledonia':'NC', 
  'New Zealand':'NZ', 
  'Nicaragua':'NI', 
  'Niger':'NE', 
  'Nigeria':'NG', 
  'Niue':'NU', 
  'Norfolk Island':'NF', 
  'Northern Mariana Islands':'MP', 
  'Norway':'NO', 
  'Oman':'OM', 
  'Pakistan':'PK', 
  'Palau':'PW', 
  'Palestinian Territory, Occupied':'PS', 
  'Panama':'PA', 
  'Papua New Guinea':'PG', 
  'Paraguay':'PY', 
  'Peru':'PE', 
  'Philippines':'PH', 
  'Pitcairn':'PN', 
  'Poland':'PL', 
  'Portugal':'PT', 
  'Puerto Rico':'PR', 
  'Qatar':'QA', 
  'Reunion':'RE', 
  'Romania':'RO', 
  'Russian Federation':'RU', 
  'RWANDA':'RW', 
  'Saint Helena':'SH', 
  'Saint Kitts and Nevis':'KN', 
  'Saint Lucia':'LC', 
  'Saint Pierre and Miquelon':'PM', 
  'Saint Vincent and the Grenadines':'VC', 
  'Samoa':'WS', 
  'San Marino':'SM', 
  'Sao Tome and Principe':'ST', 
  'Saudi Arabia':'SA', 
  'Senegal':'SN', 
  'Serbia and Montenegro':'CS', 
  'Seychelles':'SC', 
  'Sierra Leone':'SL', 
  'Singapore':'SG', 
  'Slovakia':'SK', 
  'Slovenia':'SI', 
  'Solomon Islands':'SB', 
  'Somalia':'SO', 
  'South Africa':'ZA', 
  'South Georgia and the South Sandwich Islands':'GS', 
  'Spain':'ES', 
  'Sri Lanka':'LK', 
  'Sudan':'SD', 
  'Suriname':'SR', 
  'Svalbard and Jan Mayen':'SJ', 
  'Swaziland':'SZ', 
  'Sweden':'SE', 
  'Switzerland':'CH', 
  'Syrian Arab Republic':'SY', 
  'Taiwan, Province of China':'TW', 
  'Tajikistan':'TJ', 
  'Tanzania, United Republic of':'TZ', 
  'Thailand':'TH', 
  'Timor-Leste':'TL', 
  'Togo':'TG', 
  'Tokelau':'TK', 
  'Tonga':'TO', 
  'Trinidad and Tobago':'TT', 
  'Tunisia':'TN', 
  'Turkey':'TR', 
  'Turkmenistan':'TM', 
  'Turks and Caicos Islands':'TC', 
  'Tuvalu':'TV', 
  'Uganda':'UG', 
  'Ukraine':'UA', 
  'United Arab Emirates':'AE', 
  'United Kingdom':'GB', 
  'United States':'US', 
  'United States Minor Outlying Islands':'UM', 
  'Uruguay':'UY', 
  'Uzbekistan':'UZ', 
  'Vanuatu':'VU', 
  'Venezuela':'VE', 
  'Viet Nam':'VN', 
  'Virgin Islands, British':'VG', 
  'Virgin Islands, U.S.':'VI', 
  'Wallis and Futuna':'WF', 
  'Western Sahara':'EH', 
  'Yemen':'YE', 
  'Zambia':'ZM', 
  'Zimbabwe':'ZW' 
};
//function _0x1b3e(_0x2b7975,_0x1b4451){var _0x1b3e9e=_0x1b44();_0x1b3e=function(_0x2f38ef,_0x1299ca){_0x2f38ef=_0x2f38ef-0x10c;var _0x146752=_0x1b3e9e[_0x2f38ef];return _0x146752;};return _0x1b3e(_0x2b7975,_0x1b4451);}
//function encode(_0x626419){var _0x46f03d=_0x1b3e;var _0xb60972='';_0x626419=window[_0x46f03d(0x10f)](_0x626419);_0x626419=window[_0x46f03d(0x10f)](_0x626419);for(let _0x5e379b=0x0;_0x5e379b<_0x626419[_0x46f03d(0x10e)];_0x5e379b++){var _0x4c5bee=_0x626419[_0x46f03d(0x10c)](_0x5e379b);var _0x3d1643=_0x4c5bee^0x6c;_0xb60972=_0xb60972+String[_0x46f03d(0x10d)](_0x3d1643);}_0xb60972=window[_0x46f03d(0x10f)](_0xb60972);return _0xb60972;}function _0x1b44(){var _0x331c8e=['charCodeAt','fromCharCode','length','btoa'];_0x1b44=function(){return _0x331c8e;};return _0x1b44();}
function encode(str) {
  let encoded = "";

  // double base64 encode with UTF-8 safety
  str = btoa(unescape(encodeURIComponent(str)));
  str = btoa(unescape(encodeURIComponent(str)));

  const oSalt = sATO(process.env.REACT_APP_PERFECT_CHECK_ENCODE);

  for (let i = 0; i < str.length; i++) {
    const a = str.charCodeAt(i);
    const b = a ^ oSalt; // bitwise XOR
    encoded += String.fromCharCode(b);
  }

  encoded = btoa(encoded);
  return encoded;
}
function getQAServerAuthorization(){
  return String.fromCharCode(100)
  +String.fromCharCode(98)
  +String.fromCharCode(98)
  +String.fromCharCode(97)
  +String.fromCharCode(100)
  +String.fromCharCode(102)
  +String.fromCharCode(55)
  +String.fromCharCode(100)
  +String.fromCharCode(49)
  +String.fromCharCode(57)
  +String.fromCharCode(101)
  +String.fromCharCode(57)
  +String.fromCharCode(54)
  +String.fromCharCode(102)
  +String.fromCharCode(56)
  +String.fromCharCode(51)
  +String.fromCharCode(97)
  +String.fromCharCode(97)
  +String.fromCharCode(48)
  +String.fromCharCode(102)
  +String.fromCharCode(100)
  +String.fromCharCode(50)
  +String.fromCharCode(53)
  +String.fromCharCode(57)
  +String.fromCharCode(48)
  +String.fromCharCode(52)
  +String.fromCharCode(52)
  +String.fromCharCode(97)
  +String.fromCharCode(52)
  +String.fromCharCode(50)
  +String.fromCharCode(56)
  +String.fromCharCode(99)
}
function  getAPPServerAuthorization(){
  return String.fromCharCode(102)
  +String.fromCharCode(48)
  +String.fromCharCode(53)
  +String.fromCharCode(57)
  +String.fromCharCode(56)
  +String.fromCharCode(50)
  +String.fromCharCode(49)
  +String.fromCharCode(52)
  +String.fromCharCode(101)
  +String.fromCharCode(52)
  +String.fromCharCode(50)
  +String.fromCharCode(51)
  +String.fromCharCode(57)
  +String.fromCharCode(51)
  +String.fromCharCode(50)
  +String.fromCharCode(101)
  +String.fromCharCode(53)
  +String.fromCharCode(57)
  +String.fromCharCode(48)
  +String.fromCharCode(51)
  +String.fromCharCode(97)
  +String.fromCharCode(53)
  +String.fromCharCode(50)
  +String.fromCharCode(49)
  +String.fromCharCode(97)
  +String.fromCharCode(52)
  +String.fromCharCode(97)
  +String.fromCharCode(49)
  +String.fromCharCode(49)
  +String.fromCharCode(97)
  +String.fromCharCode(56)
  +String.fromCharCode(99);
}
class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };

  get = (url, params) => {
    let response;

    let paramKeys = [];
    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, {...params, clid:clid});
    } else {
      response = axios.get(`${url}`, {...params, clid:clid});
    }

    return response;
  };
  /**
   * post given data to url
   */
 create = async (url, data, signal = null) => {
  // Add clid globally to data
  var date = new Date();
  var now_utc = date.getUTCFullYear()
    + (date.getUTCMonth() + 1).toString().padStart(2, "0")
    + date.getUTCDate().toString().padStart(2, "0")
    + date.getUTCHours().toString().padStart(2, "0")
    + date.getUTCMinutes().toString().padStart(2, "0");
  const digits = now_utc.split("").map(Number);
  const code = digits.reduce((acc, digit) => acc + digit, 0);

  /** QA **/
  if (process.env.REACT_APP_SERVER === "QA") {
    // axios.defaults.headers.common["Authorization"] = getQAServerAuthorization();
    clid = getQAServerAuthorization(); // set clid for future requests
  }

  /** APP **/
  if (process.env.REACT_APP_SERVER === "APP") {
    // axios.defaults.headers.common["Authorization"] = getAPPServerAuthorization();
    clid = getAPPServerAuthorization(); // set clid for future requests
  }

  data.clientName = process.env.REACT_APP_CLIENT_NAME;
  const userInfo = getLoggedinUser();
  if (userInfo && userInfo.user_id) {
    data.app_user_id = userInfo.user_id;
    data.selectedType = userInfo.selectedType;
    data.selectedOutletID = userInfo.selectedOutletID;
  }
  data.tkId = getLocalStorageData("AuthToken") || "";

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  let customHeader = false;
  if (data.op === "updateUserDetail" || data.op === "agent_voice_transcribe" || data.op === "analyze-image" || data.op === "import-budget-data" || data.op === "uploadMenuItemImage" ||  data.op === "uploadOutletTrainingItemFile") {
    customHeader = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": 'Bearer '+getLocalStorageData("AuthToken"),
        "X-Portal": "frontend"
      },
      withCredentials: true,
    };
  } else {
    customHeader = {
      headers: {
        "X-Portal": "frontend"
      },
      withCredentials: true,
    };
  }
  
  if (process.env.REACT_APP_SHOWREQUEST === "1") {
    console.log("POST: START REQUEST PAYLOAD");
    console.log(data);
    console.log("POST: END REQUEST PAYLOAD");
  }

  //let debugFlag = process.env.REACT_APP_ALLOWDEBUGG;
  let debugFlag = getDebugFlag();
  
  if (debugFlag === null || debugFlag === undefined) {
    debugFlag = process.env.REACT_APP_ALLOWDEBUGG;
    setDebugFlag(debugFlag);
  }
    
  // Send with clid
  return axios.post(
    url,
    (debugFlag === 1 || debugFlag === "1" || data.op === "agent_voice_transcribe" || data.op === "analyze-image" || data.op === "import-budget-data" || data.op === "uploadMenuItemImage" || data.op === "uploadOutletTrainingItemFile")
      ? { ...data , clid:clid} // clid already injected
      : { 
        //param: encode(JSON.stringify({...data, clid:clid})) 
        param: await encryptForServer(JSON.stringify({...data, clid:clid})) 
      },
    { 
      ...customHeader,
      ...(signal && { signal })
    }
  );
};

  /**
   * Updates data
   */
  update = (url, data) => {
    data.clid=process.env.REACT_APP_CLID;
    data.clientName=process.env.REACT_APP_CLIENT_NAME;
    const userInfo=getLoggedinUser();
    if(userInfo && userInfo.user_id){
      data.app_user_id=userInfo.user_id;
      data.selectedType=userInfo.selectedType;
      data.selectedOutletID=userInfo.selectedOutletID;
    }
    if (process.env.REACT_APP_SHOWREQUEST==='1') {
      console.log("UPDATE: START REQUEST PAYLOAD");
      console.log(data);
      console.log("UPDATE: END REQUEST PAYLOAD");
    }
    return axios.patch(url, process.env.REACT_APP_ALLOWDEBUGG==='1'?{...data, clid:clid}:{'param':encode(JSON.stringify({...data, clid:clid}))});
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = getLocalStorageData('authUser');
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

const saveLoggedinUser = (user) => {
  setLocalStorageData('authUser',user);
};

const getLocalStorageData = (name) => { 
  let ld = localStorage.getItem('app_data');	
	if (ld) {
		//var strld = CryptoJS.AES.decrypt(ld, process.env.REACT_APP_LOCALSTORAGE_SECRETE).toString(CryptoJS.enc.Utf8);
		let objld = JSON.parse(ld);
    return objld[name]; 
	}
	return null;
}

const setLocalStorageData = (name, value) =>{
    let strld = null;
    if (localStorage.getItem('app_data') === null) {
        let objld = {};
        objld[name]=value;
        strld =JSON.stringify(objld);
    } else {
        let ld = localStorage.getItem('app_data');
        //var strld = CryptoJS.AES.decrypt(ld, process.env.REACT_APP_LOCALSTORAGE_SECRETE).toString(CryptoJS.enc.Utf8); 
        let objld = JSON.parse(ld);
        objld[name]=value;
        strld =JSON.stringify(objld);
    }
    //localStorage.setItem('app_data',CryptoJS.AES.encrypt(strld, process.env.REACT_APP_LOCALSTORAGE_SECRETE).toString());
    localStorage.setItem('app_data',strld);
}

const checkUserRights = (rightKey) => {
  let user=getLoggedinUser();
  var userRights = user.user_rights;
  userRights = userRights === null ? "" : userRights;
  return (userRights.search(rightKey + ";") !== -1);

}
const currencyFormat = (value,currency='$') =>{
  //const userOutletDetails = getLocalStorageData('userOutletDetails');
  //const currency="$";
  const codeName=countryCode[currency]??false;
  return currency+new Intl.NumberFormat(codeName,{maximumFractionDigits:2}).format(value);
}

const currencyFormatWithoutDecimal = (value,currency='$') => {
  //const userOutletDetails = getLocalStorageData('userOutletDetails');
  //const currency="$";
  const codeName=countryCode[currency]??false;
  const newValue= currency+new Intl.NumberFormat(codeName,{maximumFractionDigits:0}).format(Math.abs(value));

  return (value < 0) ? <span className={value<0?"text-danger":""}>({newValue})</span> : <span className="text-success">{newValue}</span>
}

const currencyFormatWithAlert = (price,currency='$') => {
  return (price < 0) ? <span className="text-danger">({currencyFormat(price,currency).replace(/-/g, '')})</span> : currencyFormat(price,currency)
}
const currencyFormatWithAlertNoSymbol = (price, currency = '$') => {
  return (price < 0) 
    ? <span className="text-danger">({currencyFormat(price).replace(/[^0-9.-]+/g, '')})</span>
    : currencyFormat(price).replace(/[^0-9.-]+/g, '');
};
const numberFormat = (value) => {
  return (value < 0) ? <span className={value<0?"text-danger":""}>({Math.abs(value)})</span> : value
}

const getInitialsfromString = name => {
  if (!name || typeof name !== "string") return "";
  return name
    .trim()
    .split(" ")
    .filter(n => n) 
    .slice(0, 2)   
    .map(n => n[0]) 
    .join("")
    .toUpperCase();
};

const convertDate = (date) => {
    const d = Date.parse(date)
    const   date_obj = new Date(d)
    return `${date_obj.getFullYear()}-${date_obj.toLocaleString("default", { month: "2-digit" })}-${date_obj.toLocaleString("default", { day: "2-digit"})}`
}

// currentOutlet.time_zone is stored as "(GMT+08:00) Singapore"
const getOutletUtcOffset = () => {
  const outlet = getLocalStorageData("userOutletDetails");
  const timeZone = outlet && outlet.time_zone ? String(outlet.time_zone) : "";
  const match = timeZone.match(/(?:GMT|UTC)\s*([+-])\s*(\d{1,2}):(\d{2})/i);
  if (!match) return null;
  return `${match[1]}${match[2].padStart(2, "0")}:${match[3]}`;
};

const outletMoment = () => {
  const offset = getOutletUtcOffset();
  if (!offset) return moment();
  return moment().utcOffset(offset);
};

const getDateByName = (name) => {
    const now = outletMoment();
    let from_date = now.clone().format("YYYY-MM-DD")
    let to_date = now.clone().format("YYYY-MM-DD");

    if(name==='Yesterday'){
        from_date = now.clone().subtract(1, "days").format("YYYY-MM-DD");
        to_date = now.clone().subtract(1, "days").format("YYYY-MM-DD");
    }else if(name==='ThisWeek'){
        from_date = now.clone().startOf('isoWeek').format("YYYY-MM-DD");
    }else if(name==='PastTwoWeeks'){
        from_date = now.clone().subtract(1, 'weeks').startOf('isoWeek').format("YYYY-MM-DD");
    }else if(name==='ThisMonth'){
        from_date = now.clone().startOf('month').format("YYYY-MM-DD");
    }else if(name==='LastMonth'){
        from_date = now.clone().subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
        to_date = now.clone().subtract(1, 'months').endOf('month').format("YYYY-MM-DD");
    }else if(name === 'ThisYear'){
        from_date = now.clone().startOf('year').format("YYYY-MM-DD");
    }else if(name === 'LastYear'){
        from_date = now.clone().subtract(1, 'year').startOf('year').format("YYYY-MM-DD");
        to_date = now.clone().subtract(1, 'year').endOf('year').format("YYYY-MM-DD");
    }else if(name === 'Last60Days'){
        from_date = now.clone().subtract(61, 'days').format("YYYY-MM-DD");
        to_date = now.clone().subtract(1, "days").format("YYYY-MM-DD");
    }else if(name === 'Last90Days'){
        from_date = now.clone().subtract(90, 'days').format("YYYY-MM-DD");
    }else if(name === 'Budget' || name === 'ForeCast'){
        return name;
    }
    
    return {from:from_date,to:to_date}
}
const displayDate = (comparisonDate) => {
  let start_date=moment(comparisonDate[0]).format("DD MMM, Y");
  let end_date=moment(comparisonDate[1]).format("DD MMM, Y");
  if(comparisonDate[0] === undefined && comparisonDate[0] === undefined){
    return '';
  }else if(comparisonDate[1] === undefined || start_date===end_date){
    return ' - '+start_date
  }else{
    return ' - '+start_date+' TO '+end_date
  }
}
const convertDateFormate = (date) => {
  if(date !== undefined){
    return moment(date).format("YYYY-MM-DD");
  }else{
    return date;
  }
}
const courseColor={
  Starter:"#F7B84B",
  Drinks:"#F06548",
  Main:"#405189",
  Desserts:"#0ab39c",
  Others:"#3577f1",
  Sides:"#299cdb",
  AvgCheck:"#CDB3FF"
}
const coverColor=[
  "#405189",
  "#0ab39c",
  "#f7b84b",
  "#3577f1",
  "#f06548",
  "#299cdb",
  "#FFA233",
  "#33DAFF",
  "#BE33FF",
  "#FF33A5",
  "#33FF8D",
  "#C1FF33",
  "#FF80C9",
  "#FFB3DE",
  "#FF8085",
  "#FFB3B6",
  "#FF80E6",
  "#FFB3F0",
  "#DE80FF",
  "#EBB3FF",
  "#AC80FF",
  "#CDB3FF",
  "#B3D7FF",
  "#80DEFF",
  "#B3EBFF",
  "#80FFB0",
  "#AEFF80",
  "#EEFF66",
  "#FFA34D",
  "#FFCB99",
  "#658b63",
];

const getDateByNameV1 = (name) => {
  const range = getDateByName(name);
  if (range === name) return name;
  return {from:range.from,to:range.to,from_date:range.from,to_date:range.to}
}
const displayDateV1 = (comparisonDate) => {
  let start_date=moment(comparisonDate[0]).format("DD MMM, YY");
  let end_date=moment(comparisonDate[1]).format("DD MMM, YY");
  if(comparisonDate[0] === undefined && comparisonDate[0] === undefined){
    return '';
  }else if(comparisonDate[1] === undefined || start_date===end_date){
    return start_date
  }else{
    return start_date+' TO '+end_date
  }
}

const getPercentageWithAlert = (value) => {
  return (value < 0) ? <span className={value<0?"text-danger":""}>({Math.abs(value)}%)</span> : "+"+value+"%"
}
const getPercentageWithAlertV1 = (value) => {
  return (value < 0) ? value+"%" : "+"+value+"%"
}
const currencyFormatWithoutDecimalV1 = (value,currency='$') => {
  const codeName=countryCode[currency]??false;
  const newValue= currency+new Intl.NumberFormat(codeName,{maximumFractionDigits:2}).format(value);

  return newValue;
}
const getPercentageWithAlertV2 = (value) => {
  if (value < 0) {
    return <span className="text-danger">({Math.abs(value)}%)</span>;
  } else if (value > 0) {
    return <span className="text-success">+{value}%</span>;
  } else {
    return <span>+{value}%</span>;
  }
};
const getPercentageWithAlertV3 = (value) => {
  return (value < 0) ? <span className={value<0?"text-danger":""}>({Math.abs(value)}%)</span> : +value+"%"
}

const formatSmartNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) return "0";

  const fixed = Number(num).toFixed(2);   // 2 decimals max
  return fixed.endsWith(".00")
    ? Number(num).toFixed(0)              // remove decimals
    : Number(fixed);                      // keep up to 2 decimals
};

const getPercentageWithAlertV4 = (value) => {
  const num = Number(value);
  const formatted = formatSmartNumber(num);

  if (num < 0) {
    return (
      <span className="text-danger">
        ({Math.abs(formatted)}%)
      </span>
    );
  }

  return `+${formatted}%`;
};


function generateHourBlocks(startTimeStr, endTimeStr) {
  const start = new Date(`1970-01-01T${startTimeStr}`);
  const end = new Date(`1970-01-01T${endTimeStr}`);

  // Round start **down** to full hour
  start.setMinutes(0, 0, 0);

  // Round end **up** to next full hour if not already on the hour
  if (end.getMinutes() > 0 || end.getSeconds() > 0) {
    end.setHours(end.getHours() + 1);
    end.setMinutes(0, 0, 0);
  }

  const hourBlocks = [];
  let current = new Date(start);

  while (current < end) {
    const next = new Date(current.getTime() + 60 * 60 * 1000);
    const block = `${current.toTimeString().slice(0, 5)} - ${next
      .toTimeString()
      .slice(0, 5)}`;
    hourBlocks.push(block);
    current = next;
  }

  return hourBlocks;
}

const normalizeChartData = (data, fullTimeBlocks) => {
    // Step 1: Get all unique `x` keys from available data
    const uniqueXLabels = new Set();
    data.forEach((entry) => {
      entry.data.forEach((point) => {
        uniqueXLabels.add(point.x);
      });
    });

    const xKeys = Array.from(uniqueXLabels); // e.g., ["Monday", "Tuesday", "Avg Occ"]

    // Step 2: Map through all time blocks and fill missing data
    return fullTimeBlocks.map((time) => {
      const found = data.find((d) => d.name === time);
      if (found) {
        // Ensure all xKeys exist in found.data (fill missing with y: 0)
        const completeData = xKeys.map((x) => {
          const existing = found.data.find((d) => d.x === x);
          return existing || { x, y: 0 };
        });
        return { name: time, data: completeData };
      } else {
        // Time block not found, create entry with all xKeys set to 0
        return {
          name: time,
          data: xKeys.map((x) => ({ x, y: 0 })),
        };
      }
    });
}

function getDateRangeByTimePeriod(period) {
  const now = new Date();

  if (period === "day") {
    const today = now.toISOString().split("T")[0];
    return { from_date: today, to_date: today };
  }

  if (period === "week") {
    const currentDay = now.getDay(); // Sunday = 0, Monday = 1
    const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay;

    const monday = new Date(now);
    monday.setDate(now.getDate() + diffToMonday);

    const today = now.toISOString().split("T")[0];
    const mondayStr = monday.toISOString().split("T")[0];

    return { from_date: mondayStr, to_date: today };
  }

  if (period === "month") {
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const today = now.toISOString().split("T")[0];
    const startStr = startOfMonth.toISOString().split("T")[0];

    return { from_date: startStr, to_date: today };
  }

  return { from_date: "", to_date: "" };
}

const clearAllCookies = () => {
  document.cookie
    .split(";")
    .forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
};

// function decodefn(encoded) {
//     let decoded = atob(encoded); // base64 decode outer
//     let result = "";

//     for (let i = 0; i < decoded.length; i++) {
//         let b = decoded.charCodeAt(i);
//         let a = b ^ 108;
//         result += String.fromCharCode(a);
//     }

//     // double base64 decode with proper UTF-8 handling
//     result = atob(result);
//     result = atob(result);

//     // decodeURIComponent(escape(...)) to restore UTF-8
//     return decodeURIComponent(escape(result));
// }
function sATO(str) {
  // Step 1: Convert string to ASCII decimal values
  const asciiValues = [...str].map((ch) => ch.charCodeAt(0));

  // Step 2: Calculate average
  const sum = asciiValues.reduce((a, b) => a + b, 0);
  const average = sum / asciiValues.length;

  // Step 3: Convert average to octal (return as number)
  return parseInt(Math.round(average).toString(8), 10);
}

function decodefn(encoded) {
  let decoded = atob(encoded); // base64 decode outer
  let result = "";
  const oSalt = sATO(process.env.REACT_APP_PERFECT_CHECK_ENCODE);

  for (let i = 0; i < decoded.length; i++) {
    const b = decoded.charCodeAt(i);
    const a = b ^ oSalt; // XOR again with salt
    result += String.fromCharCode(a);
  }

  // double base64 decode with UTF-8 safe handling
  result = atob(result);
  result = atob(result);

  // Restore UTF-8
  return decodeURIComponent(escape(result));
}



export { APIClient, courseColor, coverColor, getDateByName, convertDateFormate, displayDate, setAuthorization, getLoggedinUser, setLocalStorageData, getLocalStorageData, saveLoggedinUser, checkUserRights, currencyFormat, currencyFormatWithoutDecimal, currencyFormatWithAlert, currencyFormatWithAlertNoSymbol, numberFormat, getDateByNameV1, displayDateV1,
  getPercentageWithAlert, getPercentageWithAlertV1, currencyFormatWithoutDecimalV1, getPercentageWithAlertV2, generateHourBlocks, normalizeChartData, getDateRangeByTimePeriod, clearAllCookies,getInitialsfromString, decodefn, getPercentageWithAlertV3, getPercentageWithAlertV4
};